import React from 'react'
import PropTypes from 'prop-types'
import { ErrorMessage, Field } from 'formik'

import { getFieldState } from 'services/Forms'
import { extractTranslation } from 'services/Utilities'
import { Card } from 'ui'

import { t } from 'translations'

const getTranslationPreview = input => {
  const translations = extractTranslation(input)
  if (typeof translations === 'string') return null

  return (
    <Card className="bg-light mt-2">
      <div className="p-3">
        <pre className="m-0">
          {Object.keys(translations).map(languageKey => {
            return (
              <div key={languageKey}>
                <b className="mr-1">{languageKey}:</b>
                {translations[languageKey]}
              </div>
            )
          })}
        </pre>
      </div>
    </Card>
  )
}
const Textarea = ({ inputGroup, customLabelElement, fieldClass, isTranslatable, ...props }) => {
  const nameFormatted = props.name.includes('values') ? props.name.replace('.values', '') : props.name

  return (
    <Field {...props}>
      {({ field, form }) => {
        const fieldState = getFieldState(form, field)
        // Get label text before otherwise required adds an asterisk next to a nonexistent label
        const labelText = t(`${props.module}.${(props.translation || nameFormatted).toUpperCase()}.LABEL`)

        return (
          <div className={`form-group ${fieldState} ${props.required ? 'required' : ''}${props.className} ${fieldClass}`}>
            {labelText !== '' && (
              <label className="control-label">
                {labelText}
                {customLabelElement}
              </label>
            )}
            <textarea
              {...props}
              {...field}
              value={field.value || props.defaultValue}
              placeholder={t(`${props.module}.${(props.translation || nameFormatted).toUpperCase()}.PLACEHOLDER`)}
              className={`form-control ${fieldState}`}
            />
            {isTranslatable ? getTranslationPreview(field.value || props.defaultValue) : null}
            <small className="form-text text-muted">{t(`${props.module}.${(props.translation || nameFormatted).toUpperCase()}.DESCRIPTION`)}</small>
            <ErrorMessage name={nameFormatted} render={msg => <span className="text-danger"> {t(msg)}</span>} />
          </div>
        )
      }}
    </Field>
  )
}

export default Textarea

// Set the proptypes for validation
Textarea.propTypes = {
  module: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  rows: PropTypes.string,
  customLabelElement: PropTypes.element
}
Textarea.defaultProps = {
  required: false,
  rows: '3',
  className: ''
}
